'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMatchFn = exports.createHLDomainLookup = exports.createLookupFn = exports.ungarble = exports.decode = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.encode = encode;
exports.trim = trim;
exports.untrim = untrim;
exports.depunc = depunc;
exports.recase = recase;

var _he = require('he');

var OPTIONS = { useNamedReferences: true };
/**
 * Encode any non-printable ASCII symbols in the string, monkey
 * patched to passed new defaults in.
 *
 * SEE: `https://github.com/mathiasbynens/he#heencodetext-options`
 *
 * @param {String}
 *
 * @returns {String}
 * @private
 */
function encode() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : OPTIONS;

  return (0, _he.encode)(str, options);
}

// Also export `he`'s decode.
exports.decode = _he.decode;

/**
 * Clean up a string (typically on that has been stripped)
 * by ensuring that there are no occurences of non-space
 * whitespace char, or double and flanking whitespace
 * chars.
 *
 * @param {String}
 *
 * @returns {String}
 * @private
 */

function trim() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return str.trim().replace(/\s+/g, ' ');
}

/**
 * Add flanking whitespaces to the string, used to
 * make sure we're not merging words as we strip.
 *
 * @param {String}
 *
 * @returns {String}
 * @private
 */
function untrim() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return ' ' + str + ' ';
}

/**
 * Clean up dumb punctuation in stripped strings.
 *
 * @param {String}
 *
 * @returns {String}
 * @private
 */
function depunc() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  // TODO: Strip ...tripple exclamations (best deal.... EVER) etc!!!.
  return str;
}

/**
 * Decapitalise string... make sure titles are not dumb.
 *
 * @param {String}
 *
 * @returns {String}
 * @private
 */
function recase() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  // TODO: Strip ...triple exclamations (best deal.... EVER) etc!!!.
  return str;
}

var ungarble = exports.ungarble = function () {
  var BREAK_TAG = '<br>';
  var GARBLED_ENTITY_RE = /\?/g;
  var GARBLED_INTENDED_BREAK_RE = / *\?*\n/;
  var GARBLED_INTENDED_BULLET_RE = /^[ ?\t]+/;

  /**
   * Detect shitty encoding a try to clean it up.
   *
   * NOTE: This specifically relates to garbage encoding in the
   * clearing sale items being recieved for listings.
   *
   * SEE: Issue #34.
   *
   * TODO: Assuming that the values in the data source are fixed,
   * we can get rid of this function.
   *
   * @param {String}
   *
   * @return {String}
   * @private
   */
  return function () {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var tokens = str.split(GARBLED_INTENDED_BREAK_RE);
    tokens = tokens.map(function (t) {
      return t.replace(GARBLED_INTENDED_BULLET_RE, ' - ').replace(GARBLED_ENTITY_RE, '');
    });
    return tokens.join(BREAK_TAG);
  };
}();

/**
 * Creates a lookup function using either an array of strings
 * (in which case it the composed funciton returns a boolean)
 * or a hash of string:string pairs.
 *
 * @param {Object|Array}
 *
 * @returns {Function}
 */
var createLookupFn = exports.createLookupFn = function createLookupFn(hash) {
  // Our lookup table.
  var table = _extends({}, hash);

  /**
   * Returns a string - the lookup result.
   *
   * @param {String}
   *
   * @returns {String}
   * @private
   */
  return function (str) {
    return table[str] || '';
  };
};

var createHLDomainLookup = exports.createHLDomainLookup = function createHLDomainLookup(strs) {
  // Strip out empty strings and grab the new length.
  strs = strs.filter(function (s) {
    return !!s;
  });
  var len = strs.length;

  /**
   * Matches `str` against the termini of all items in
   * the corpus.
   *
   * @param {Array}
   *
   * @returns {Function}
   * @private
   */
  return function () {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (!str) return false;

    for (var i = 0; i < len; i++) {
      var current = strs[i];
      var index = str.indexOf(current);

      // Bail for an exact match.
      if (str === current) return true;

      // Does the string match a terminal domain in the corpus?
      if (index !== -1 && str.charAt(index - 1) === '.' && index + current.length === str.length) return true;
    }

    return false;
  };
};

var createMatchFn = exports.createMatchFn = function createMatchFn(strs) {
  // Strip out empty strings and grab the new length.
  strs = strs.filter(function (s) {
    return !!s;
  });
  var len = strs.length;

  /**
   * Returns a matcher function - does the string exist in the corpus?
   *
   * @param {Array}
   *
   * @returns {Function}
   * @private
   */
  return function () {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    for (var i = 0; i < len; i++) {
      var current = strs[i];
      if (str === current) return true;
    }

    return false;
  };
};